// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__OCqsj","row":"ProcedureTreatmentSummary_row__2jXpd"};